import { appLanguage, deleteConfirmation ,editorTheme, generatorView, loggingAllowed, preferredEditor, showLogInfo, tooltips } from "../constants/profileSettings";

class Profile {
  public generatorView: string;
  public preferredEditor: string;
  public editorTheme: string;
  public appLanguage: string;
  public showTooltips: tooltips;
  public loggingAllowed: loggingAllowed;
  public showLogInfo: showLogInfo;
  public deleteConfirmation: deleteConfirmation;

  public constructor() {
    this.generatorView = generatorView.cardView;
    this.preferredEditor = preferredEditor.codeEditor;
    this.editorTheme = editorTheme.vsLight;
    this.appLanguage = appLanguage.english;
    this.showTooltips = tooltips.on;
    this.loggingAllowed = loggingAllowed.true;
    this.showLogInfo = showLogInfo.true;
    this.deleteConfirmation = deleteConfirmation.true;
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/models/Profile.ts